<!--
 * @Author: maolin lin.mao3@gientech.com
 * @Date: 2024-08-02 15:37:02
 * @Description: 
-->
<template>
  <el-time-picker
      class="lc-time-picker"
      v-model="timePicker"
      popper-class="lc-time-picker-popper"
      clear-icon="el-icon-error"
      v-bind="configs"
      @mouseenter.native="handleTimePickerEnter"
      @mouseleave.native="handleTimePickerLeave"
      @focus="initTimeButton"
    />
</template>

<script>
export default {
  name: 'LcTimePicker',
  props: {
    value: {
      type: [Date, String],
      default: ''
    },
    configs: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      timePicker: ''
    };
  },
  watch: {
    timePicker(val){
      this.$emit('input', val)
    }
  },
  mounted() {
    this.timePicker = this.value;
    this.adjustTimeIconPosition();
  },
  methods: {
    // 调整图标位置
    adjustTimeIconPosition() {
        let parentDoms = document.getElementsByClassName('lc-time-picker');
        for (let i = 0; i < parentDoms.length; i++) {
          let dom = parentDoms[i];
          const iconDom = dom?.getElementsByClassName('el-input__prefix')[0];
          iconDom?.setAttribute('class', 'el-input__suffix is-time');
        }
      },
      // 初始化footer按钮
      initTimeButton() {
        this.$nextTick(() => {
          let footerDom = null;
          const popperDoms = document.getElementsByClassName('lc-time-picker-popper');
          if(popperDoms.length>0) {
            for(let i=0;i<popperDoms.length;i++) {
              if(popperDoms[i].getAttribute('style')?.indexOf('display:none') === -1) {
                footerDom = popperDoms[i].getElementsByClassName('el-time-panel__footer')[0]
              }
            }
          }
          if (!footerDom) return;
          if (footerDom.getElementsByClassName('el-time-panel__btn current').length) return;
          const confirmBtn = footerDom.getElementsByClassName('el-time-panel__btn confirm')[0];
          const currentTimeBtn = document.createElement('button');
          currentTimeBtn.innerHTML = '当前时间';
          currentTimeBtn.setAttribute('class', 'el-time-panel__btn current');
          currentTimeBtn.addEventListener('click', () => {
            this.timePicker = new Date();
            this.$nextTick(() => {
              const ulList = window.document.getElementsByClassName('el-time-spinner__wrapper');
            if (ulList?.length) {
              Array.from(ulList).forEach(dom => {
                dom.dispatchEvent(new MouseEvent('mousemove'))
              });
            }
            })
          });
          footerDom.insertBefore(currentTimeBtn, confirmBtn);
        });
      },
      handleTimePickerEnter(event) {
        let val = this.timePicker;
        const parentDom = event.currentTarget;
        const iconDom = parentDom?.getElementsByClassName('el-input__suffix is-time')[0];
        iconDom?.setAttribute('style', val ? 'display:none' : 'display:block');
      },
      handleTimePickerLeave(event) {
        let val = this.timePicker;
        const parentDom = event.currentTarget;
        const inputDom = parentDom.getElementsByClassName('el-input__inner')[0];
        inputDom?.setAttribute('style', 'border-color: #C0C4CC');
      }
  },
};
</script>
